import { render, staticRenderFns } from "./TokenName.vue?vue&type=template&id=3e79c5ff&"
import script from "./TokenName.vue?vue&type=script&lang=js&"
export * from "./TokenName.vue?vue&type=script&lang=js&"
import style0 from "./TokenName.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e79c5ff')) {
      api.createRecord('3e79c5ff', component.options)
    } else {
      api.reload('3e79c5ff', component.options)
    }
    module.hot.accept("./TokenName.vue?vue&type=template&id=3e79c5ff&", function () {
      api.rerender('3e79c5ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppTokenDisplay/TokenName.vue"
export default component.exports